module.exports = __webpack_public_path__ + "static/media/slider-l3-360.5d7bc78a.webp";